import {NgModule} from '@angular/core';
import {ClipboardService} from '@app/presentation/services/clipboard/clipboard.service';
import {ShareService} from "@app/presentation/services/share/share.service";


@NgModule({
    providers: [
        ShareService,
        ClipboardService
    ]
})
export class ShareServiceModule { }
